import { find } from 'lodash';

const DualOptionSetsSingleAnswer = ({ data, question }) => {
  const optionSetKey = question.question_version > 1 ? 'option-set' : 'key';
  const optionKey = question.question_version > 1 ? 'option' : 'value';

  const entryOptionSet = data[0][optionSetKey];
  const entryOption = data[0][optionKey];

  const questionOptionSet = find(question.question_data.questions, {
    [optionSetKey]: entryOptionSet,
  });
  const questionOption = questionOptionSet
    ? find(questionOptionSet.options, {
        key: entryOption,
      })
    : null;

  return questionOption ? questionOption.title : null;
};

export default DualOptionSetsSingleAnswer;
